import Ajv from "ajv";
const moment = require("moment");

/**
 * Generate UTC timestamps with specified minutes offset
 * @param {number} minutes - Minutes to subtract (defaults to 1440 if not provided)
 * @returns {Object} Object with startDate and endDate in YYYY-MM-DDTHH:mm format
 */
export function getDefaultTimeStamp(minutes) {
  const DEFAULT_MINUTES_IN_A_DAY = 1440;
  const effectiveMinutes = !isNaN(minutes) ? minutes : DEFAULT_MINUTES_IN_A_DAY;
  const utcTime = moment.utc();
  const pastTime = utcTime.clone().subtract(effectiveMinutes, "minutes");

  return {
    endDate: utcTime.format("YYYY-MM-DDTHH:mm"),
    startDate: pastTime.format("YYYY-MM-DDTHH:mm"),
  };
}

/**
 * Alias for getDefaultTimeStamp for backward compatibility
 */
export const bedasgetDefaultTimeStamp = getDefaultTimeStamp;

/**
 * Get UTC timestamps with specified minutes offset
 * @param {number} minutes - Minutes to subtract from current UTC time
 * @returns {Object} Object with startDate and endDate or undefined
 */
export default function getTimestamps(minutes) {
  if (!isNaN(minutes)) {
    const utcTime = moment.utc();
    const pastTime = utcTime.subtract(minutes, "minutes");
    return {
      endDate: utcTime.format("YYYY-MM-DDTHH:mm"),
      startDate: pastTime.format("YYYY-MM-DDTHH:mm"),
    };
  }
}

/**
 * Alias for getTimestamps for backward compatibility
 */
export const bedasgetTimestamps = getTimestamps;

/**
 * Format date with padded values
 * @param {Date} date - Date to format
 * @returns {string} Formatted date string YYYY-MM-DD HH:mm:ss
 */
// export const formatDate = (date) => {
//   const pad = (n) => String(n).padStart(2, "0");
//   return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
// };


 //Default for Remote Ops 
  export const getDefaultTimestamps = () => {
    const endTime = moment.utc();
    const startTime = moment.utc().subtract(24, 'hours');
    return {
      startTS: startTime.format("YYYY-MM-DDTHH:mm"),
      endTS: endTime.format("YYYY-MM-DDTHH:mm")
    };
  };

   // Initialize timestamps with defaults if not provided by context
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    console.error("Invalid date format:", dateString);
    return null;
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

/**
 * Get EM Core timestamps with base date of 2015-12-24
 * @param {number} minutes - Minutes to subtract from base date
 * @returns {Object} Object with startDate and endDate or console.log error
 */
export function getEmCoreTimestamps(minutes) {
  if (!isNaN(minutes)) {
    const startDate = new Date('2015-12-24 00:00:00');
    const currentDate = formatDate(startDate);
    const pastDate = new Date(startDate.getTime() - minutes * 60000);
    const minsSubStractDate = formatDate(pastDate);

    return {
      endDate: currentDate,
      startDate: minsSubStractDate,
    };
  } else {
    console.log("Invalid Time Selected");
  }
}
export const getEMCoreFilteredData = (data, startTS, endTS) => {
  const selectedStartTime = new Date(startTS).getTime();
  const selectedEndTime = new Date(endTS).getTime();
  const filteredData = data.filter(item => {
    const itemTS = new Date(item.timestamp).getTime();
    return itemTS >= selectedStartTime && itemTS < selectedEndTime;
  });
  return filteredData;
}


/**
 * Convert Unix timestamps to readable date format
 * @param {Array<number>} timestamps - Array of Unix timestamps (in seconds)
 * @returns {Array<string>} Array of formatted date strings
 */
export const emCoreUnixTimestampConvert = (timestamps) => {
  return timestamps.map(ts => {
    const date = new Date(ts * 1000);
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  });
};
// ===== Color Legend Mappings =====
const ALARM_SEVERITY_COLORS = {
  "Critical": "#CC0815",
  "Earth Fault": "#CC0815",
  "Overcurrent Fault": "#F2AC66",
  "High": "#F2AC66",
  "Medium": "#FFD800",
  "Informational": "#0052FF",
  "Ok": "#51A34B",
};

/**
 * Get color code for alarm severity level
 * @param {string} label - Alarm severity label
 * @returns {string|null} Color hex code or null if invalid
 */
export function getAlarmSummaryLegendsColor(label) {
  return ALARM_SEVERITY_COLORS[label] || null;
}

const FAULT_TYPE_COLORS = {
  "Differential Current": "#FF9F8C",
  "Overload": "#B03A2E",
  "Single Phase Earth Fault": "#5C0006",
  "Phase C to ground fault": "#E12E2E",
  "Underfrequency": "#FF99A0",
  "Phase Unbalance": "#ED5739",
  "Voltage Protection": "#A65503",
  "Thermal Overload": "#E74C3C",
  "Overcurrent Protection": "#EC7063",
  "Overvoltage": "#F1948A",
  "Directional Earth-Fault": "#F2D7D5",
  "Three-phase fault": "#943126",
  "Breaker Failure": "#F0B27A",
  "Arc Detected": "#EDBB99",
  "Phase B to ground fault": "#D35400",
  "Phase A to ground fault": "#D35488",
};

/**
 * Get color code for event log function/fault type
 * @param {string} label - Fault type label
 * @returns {string|null} Color hex code or null if invalid
 */
export function getEventLogByFunctionLegends(label) {
  return FAULT_TYPE_COLORS[label] || null;
}
const USER_ROLE_COLORS = {
  "Administrator": "#FF4C4C",
  "Operator": "#0000FF",
  "Viewer": "#964B00",
  "Engineer": "#FFC0CB",
  "Local HMI": "#008080",
  "Ok": "#51A34B",
};

/**
 * Get color code for user role
 * @param {string} label - User role label
 * @returns {string|null} Color hex code or null if invalid
 */
export function getuserLegendsColor(label) {
  return USER_ROLE_COLORS[label] || null;
}

const ASSET_MODEL_COLORS = {
  "REX615": "#FF4C4C",
  "REX640": "#0000FF",
  "SSC600": "#964B00",
};

/**
 * Get color code for asset model
 * @param {string} label - Asset model label
 * @returns {string|null} Color hex code or null if invalid
 */
export function getassetModelLegendsColor(label) {
  return ASSET_MODEL_COLORS[label] || null;
}

const FAULT_DURATION_COLORS = {
  "<2 seconds": "#E74C3C",
  "2-3 seconds": "#FF9F8C",
  "4-5 seconds": "#ED5739",
  "6-10 seconds": "#5C0006",
  ">10 seconds": "#E12E2E",
};

/**
 * Get color code for fault duration range
 * @param {string} label - Duration range label
 * @returns {string|null} Color hex code or null if invalid
 */
export function getFaultDurationLegendsColor(label) {
  return FAULT_DURATION_COLORS[label] || null;
}
// ===== Status Icon Mapping =====
const STATUS_ICONS = {
  "Closed": { icon: "abb/information-circle-1", class: "closed" },
  "Charged": { icon: "abb/information-circle-1", class: "charged" },
  "Discharged": { icon: "abb/warning-circle-1", class: "discharged" },
  "Sufficient": { icon: "abb/check-mark-circle-1", class: "charged" },
  "Insufficient": { icon: "abb/warning-circle-1", class: "discharged" },
  "Normal": { icon: "abb/check-mark-circle-1", class: "charged" },
  "Tripped": { icon: "abb/warning-triangle", class: "tripped" },
  "Failed": { icon: "abb/error-circle-1", class: "failed" },
};

/**
 * Get icon and class for operational status
 * @param {string} status - Status label
 * @returns {Object} Object with icon name and CSS class
 */
export function getOpsStatusIcon(status) {
  return STATUS_ICONS[status] || { icon: "abb/check-mark-circle-1", class: "check-icon" };
}
// ===== URL Utilities =====

/**
 * Replace time parameters in URL query string
 * @param {string} url - Base URL
 * @param {string} startTimeKey - Start time parameter name
 * @param {string} newStartTime - New start time value
 * @param {string} endTimeKey - End time parameter name
 * @param {string} newEndTime - New end time value
 * @returns {string} Updated URL with decoded parameters
 */
export function replaceUrlParam(url, startTimeKey, newStartTime, endTimeKey, newEndTime) {
  const currentUrl = new URL(url);
  currentUrl.searchParams.set(startTimeKey, newStartTime);
  currentUrl.searchParams.set(endTimeKey, newEndTime);
  return decodeURIComponent(currentUrl.href);
}

// ===== JSON Validation Utilities =====

/**
 * Validate JSON data against a schema
 * @param {Object} jsonData - Data to validate
 * @param {Object} jsonSchema - JSON schema to validate against
 */
export const validateJson = (jsonData, jsonSchema) => {
  const ajv = new Ajv();
  const validate = ajv.compile(jsonSchema);
  const isDataValid = validate(jsonData);

  if (isDataValid) {
    console.log('Success! data matches the predefined schema.');
  } else {
    const errorMessages = validate.errors.map((err) => `Error at ${err.instancePath}: ${err.message}`);
    console.error('Validation Errors:', errorMessages);
  }
};

/**
 * Check if a JSON string is valid JSON
 * @param {string} jsonString - String to validate
 * @returns {boolean} True if valid JSON, false otherwise
 */
export const isJsonValid = (jsonString) => {
  try {
    JSON.parse(jsonString);
    return true;
  } catch (e) {
    return false;
  }
};


// Ajv instance cache
let ajvInstance = null;

/**
 * Get or create cached Ajv instance
 * @returns {Object} Ajv instance
 */
const getAjv = () => {
  if (!ajvInstance) {
    ajvInstance = new Ajv({
      strict: false,
      removeAdditional: true,
      allErrors: true,
    });
  }
  return ajvInstance;
};

/**
 * Validate JSON data against a schema with optional error filtering
 * @param {Object} schema - The JSON schema
 * @param {Array<string>} ignoredProperties - Property names to ignore errors for
 * @returns {Object} Validation result with success status and error messages
 */
export const validateJsonSchema = (schema, ignoredProperties = []) => {
  const ajv = getAjv();
  const validate = ajv.compile(schema);
  const isValid = validate(schema);

  if (isValid) {
    console.log('Validation succeeded!');
    return { success: true };
  }

  const filteredErrors = validate.errors.filter((err) => {
    return !ignoredProperties.some((prop) => err.message.includes(`'${prop}'`));
  });

  if (filteredErrors.length > 0) {
    const errorMessages = filteredErrors.map((err) => `Error at ${err.instancePath}: ${err.message}`);
    console.error('Validation Errors:', errorMessages);
    return { success: false, errors: errorMessages };
  }

  console.log('Validation succeeded with ignored errors.');
  return { success: true, ignoredErrors: validate.errors };
};

/**
 * Check if a JSON string is valid
 * @param {string} jsonString - String to validate
 * @returns {boolean} True if valid JSON, false otherwise
 */
export const isJsonValidSchema = (jsonString) => {
  try {
    JSON.parse(jsonString);
    return true;
  } catch {
    return false;
  }
};

// ===== Date/Time Conversion Utilities =====

/**
 * Convert UTC date string to local time format (YYYY-MM-DD HH:mm)
 * @param {string} utcDateString - UTC date string
 * @returns {string} Local time formatted as YYYY-MM-DD HH:mm or 'NULL'
 */
export function convertUtcToLocalString(utcDateString) {
  if (!utcDateString) return "NULL";
  const utcDate = new Date(utcDateString + " UTC");
  const localISOString = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000).toISOString();
  return localISOString.replace("T", " ").substring(0, 16);
}

/**
 * Convert UTC date string to local time format for DR (MM/DD/YYYY HH:mm)
 * @param {string} drfaulttime - UTC date string
 * @returns {string} Local time formatted as MM/DD/YYYY HH:mm or 'NULL'
 */
export function convertUtcToLocalStringDR(drfaulttime) {
  if (!drfaulttime) return "NULL";
  const utcDate = new Date(drfaulttime + " UTC");
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };
  return utcDate.toLocaleString("en-US", options);
}

// ===== Encryption Utilities =====
// Note: Uses Base64 encoding. This is NOT cryptographically secure.
// For sensitive data, use proper encryption libraries like crypto-js or libsodium

/**
 * Encrypt data using Base64 encoding (not cryptographically secure)
 * @param {Object} data - Data to encrypt
 * @returns {string|null} Base64 encoded string or null on error
 */
export const encryptData = (data) => {
  try {
    return window.btoa(JSON.stringify(data));
  } catch (error) {
    console.error("Encryption failed:", error);
    return null;
  }
};

/**
 * Decrypt Base64 encoded data
 * @param {string} encryptedData - Base64 encoded string
 * @returns {string|null} Decrypted string or null on error
 */
export const decryptData = (encryptedData) => {
  try {
    return window.atob(encryptedData);
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};






// ===== Formatting Utilities =====

/**
 * Format date to MM/DD/YYYY HH:mm:ss format
 * @param {Date} date - Date to format
 * @returns {string} Formatted date string
 */
export function formatDateTimeHhMmSs(date) {
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}


export function formatDateTime(date) {
  const pad = (n) => (n < 10 ? "0" + n : n);

  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const year = date.getFullYear();

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
}